import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { PermisosService } from "src/app/services/permisos.service";

@Directive({
  selector: "[hasPermission]",
})
export class HasPermissionDirective {
  @Input() set hasPermission(permission: string) {
    this.viewContainer.clear();
    if (this.permisosServ.getPermisos().includes(permission)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permisosServ: PermisosService
  ) {}
}
